module.exports = __webpack_public_path__ + "static/media/hollywoodxposed-background-image.6e541237.png";